import React, { useState, useEffect } from 'react';
import riddles from '../data/riddles';

// ✅ دالة النطق
const speakText = (text) => {
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = 'ar-SA'; // اللغة العربية السعودية
  utterance.rate = 1;
  speechSynthesis.speak(utterance);
};

const QuestionPanel = ({ letter, onQuestionReady }) => {
  const [showAnswer, setShowAnswer] = useState(false);
  const [currentRiddleIndex, setCurrentRiddleIndex] = useState(0);

  const availableRiddles = Array.isArray(riddles[letter]) ? riddles[letter] : [];
  const currentRiddle = availableRiddles[currentRiddleIndex] || {
    riddle: 'عذراً، لا توجد ألغاز متاحة لهذا الحرف حالياً.',
    answer: ''
  };

  // ✅ عند تغيير اللغز: بلّغ الأب وشغّل النطق + طباعة
  useEffect(() => {
    
    

    onQuestionReady(currentRiddle.riddle);
    speakText(currentRiddle.riddle);
  }, [currentRiddle.riddle, onQuestionReady]);

  const handleNextRiddle = () => {
    if (availableRiddles.length > 1) {
      const nextIndex = (currentRiddleIndex + 1) % availableRiddles.length;
      setCurrentRiddleIndex(nextIndex);
      setShowAnswer(false);
    }
  };

  return (
    <div className="p-4 text-center">
      
      <h2 className="text-xl font-bold mb-2 text-purple-700">
        اللغز لحرف "{letter}" 👇
      </h2>

      <div className="riddle-box">
        <p className="text-lg mb-4">{currentRiddle.riddle}</p>
        <button
          onClick={() => speakText(currentRiddle.riddle)}
          className="mt-2 bg-yellow-400 hover:bg-yellow-500 text-black px-4 py-2 rounded-lg text-sm"
        >
          🔊 استمع مجددًا
        </button>
      </div>

      <button
        onClick={() => setShowAnswer(!showAnswer)}
        className="reveal-button"
      >
        {showAnswer ? 'إخفاء الجواب' : 'عرض الجواب الصحيح'}
      </button>

      {showAnswer && currentRiddle.answer && (
        <p className="mt-4 text-lg text-green-600 font-bold">
          {currentRiddle.answer}
        </p>
      )}

      {availableRiddles.length > 1 && (
        <button
          onClick={handleNextRiddle}
          className="next-button"
        >
          لغز آخر 🔁
        </button>
      )}
    </div>
  );
};

export default QuestionPanel;
